var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { Container, FormGroup, Input, CardBody, CardFooter, Card, Form } from 'reactstrap';
import { SwatchesPicker } from 'react-color';
import { FormattedMessage, injectIntl } from 'react-intl';
import Color from 'color';
import { ApplicationContext } from '../../../ApplicationContext';
import LabelModel from '../../../models/LabelModel';
import CardTitleHeader from '../../components/ui/Cards/CardTitleHeader';
import FormField from '../../components/ui/FormField/FormField';
import CloseButton from '../../components/ui/CloseButton/CloseButton';
import { FormErrorContext } from '../../../FormErrorContext';
import Signals from '../../../signals/Signals';
import { createErrorResponse } from '../../../utils/errorUtils';
import CreateLabelCommand from '../../../commands/labels/CreateLabelCommand';
/**
 *
 */
var LabelOverlay = /** @class */ (function (_super) {
    __extends(LabelOverlay, _super);
    /**
     *
     * @param props
     */
    function LabelOverlay(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            displayColorPicker: false,
            errors: [],
            submitting: false,
            labelModel: new LabelModel(props.labelModel)
        };
        _this.onColorChange = _this.onColorChange.bind(_this);
        _this.onInputChange = _this.onInputChange.bind(_this);
        _this.onCancel = _this.onCancel.bind(_this);
        _this.onSubmit = _this.onSubmit.bind(_this);
        _this.onSuccess = _this.onSuccess.bind(_this);
        _this.onError = _this.onError.bind(_this);
        return _this;
    }
    /**
     *
     */
    LabelOverlay.prototype.render = function () {
        var _this = this;
        var className = this.props.className;
        var _a = this.state, displayColorPicker = _a.displayColorPicker, labelModel = _a.labelModel;
        return React.createElement(Container, { className: 'label-overlay w-100 ' + className },
            React.createElement(FormErrorContext.Provider, { value: { errors: this.state.errors } },
                React.createElement(Form, { onChange: this.onInputChange, onSubmit: this.onSubmit },
                    React.createElement(Card, { className: "bg-white" },
                        React.createElement(CardTitleHeader, { title: "Label" }),
                        React.createElement(CardBody, null,
                            React.createElement("div", { className: "row" },
                                React.createElement("div", { className: "col-12 col-md-3" },
                                    React.createElement(FormGroup, null,
                                        React.createElement("div", { className: "row" },
                                            React.createElement("div", { className: "col" },
                                                React.createElement("label", { htmlFor: "name" },
                                                    React.createElement(FormattedMessage, { id: "page.labels.field.name" })))),
                                        React.createElement(FormField, null,
                                            React.createElement(Input, { id: "name", type: "text", name: "name", required: true, maxLength: 50, value: labelModel.name })))),
                                React.createElement("div", { className: "col-12 col-md-6" },
                                    React.createElement(FormGroup, null,
                                        React.createElement("div", { className: "row" },
                                            React.createElement("div", { className: "col" },
                                                React.createElement("label", { htmlFor: "description" },
                                                    React.createElement(FormattedMessage, { id: "page.labels.field.description" })))),
                                        React.createElement(FormField, null,
                                            React.createElement(Input, { id: "description", type: "text", name: "description", maxLength: 255, value: labelModel.description })))),
                                React.createElement("div", { className: "col-12 col-md-3" },
                                    React.createElement(FormGroup, null,
                                        React.createElement("div", { className: "row" },
                                            React.createElement("div", { className: "col" },
                                                React.createElement("label", { htmlFor: "color" },
                                                    React.createElement(FormattedMessage, { id: "page.labels.field.color" })))),
                                        React.createElement(FormField, null,
                                            React.createElement(Input, { id: "color", name: "color", type: "text", style: {
                                                    borderColor: labelModel.getTextColor(),
                                                    backgroundColor: labelModel.color,
                                                    color: labelModel.getTextColor()
                                                }, onFocus: function () {
                                                    _this.setState({ displayColorPicker: !displayColorPicker });
                                                }, value: labelModel.color.hex() }),
                                            displayColorPicker &&
                                                React.createElement("div", { style: { position: 'fixed' } },
                                                    React.createElement(SwatchesPicker, { color: labelModel.color.hex(), onChange: this.onColorChange }))))))),
                        React.createElement(CardFooter, null,
                            React.createElement("div", { className: "d-flex justify-content-end" },
                                React.createElement("button", { className: "btn btn-outline-primary mr-3", type: "button", onClick: this.onCancel },
                                    React.createElement(FormattedMessage, { id: "page.labels.cancel" })),
                                React.createElement("button", { className: "btn btn-primary", type: "submit" },
                                    React.createElement(FormattedMessage, { id: "page.labels.save" }))))))),
            React.createElement(CloseButton, { onClick: function () {
                    Signals.HideOverlay.dispatch();
                } }));
    };
    /**
     *
     * @param color
     */
    LabelOverlay.prototype.onColorChange = function (color) {
        var labelModel = this.state.labelModel;
        labelModel.color = new Color(color.hex);
        this.setState({ displayColorPicker: false });
    };
    /**
     *
     * @param event
     */
    LabelOverlay.prototype.onInputChange = function (event) {
        var labelModel = this.state.labelModel;
        switch (event.target.name) {
            case 'color':
                // ignore
                break;
            default:
                console.log(event.target.name, event.target.value);
                labelModel[event.target.name] = event.target.value;
        }
    };
    /**
     *
     * @param event
     */
    LabelOverlay.prototype.onSubmit = function (event) {
        event.preventDefault();
        var session = this.context.session;
        var labelModel = this.state.labelModel;
        var intl = this.props.intl;
        var labelCollection = this.context.labelCollection;
        var command = new CreateLabelCommand();
        command.execute(labelModel, session.user.organisation.id, labelCollection, intl)
            .then(this.onSuccess)
            .catch(this.onError);
    };
    /**
     *
     */
    LabelOverlay.prototype.onCancel = function () {
        Signals.HideOverlay.dispatch();
    };
    LabelOverlay.prototype.onSuccess = function () {
        var labelModel = this.state.labelModel;
        this.props.labelModel.update(labelModel);
        Signals.LabelModelAdded.dispatch(labelModel);
        this.setState({ errors: null, submitting: true });
        Signals.HideOverlay.dispatch();
    };
    LabelOverlay.prototype.onError = function (error) {
        createErrorResponse(this, error);
    };
    LabelOverlay = __decorate([
        observer
    ], LabelOverlay);
    return LabelOverlay;
}(React.Component));
LabelOverlay.contextType = ApplicationContext;
export default injectIntl(LabelOverlay);
